import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { OrganizationSubscriptionHandler, Subscriptions } from "@core/data/globals/subscriptions";
import { Store } from "@ngxs/store";

enum PathType {
    TASTINGS = 'tastings',
    EVALUATION = 'evaluation',
    REPORTING = 'reporting'
}

@Injectable()
export class SubscriptionGuard implements CanActivate {
    constructor(
        private _router: Router,
        private _store: Store,
        private _subscriptionHandler: OrganizationSubscriptionHandler,
    ) {}

    private tastingsPaths: string[] = [
        'org/:orgKey/tastings-samples',
        'org/:orgKey/tastings-events',
        'org/:orgKey/tastings-contacts',
        'org/:orgKey/tastings-scores/:type/:subjectKey',
        'org/:orgKey/tastings-indexes',
        'org/:orgKey/tastings-tags',
        'org/:orgKey/tastings-weighted-chars',
    ];

    private evaluationPaths: string[] = [
        'org/:orgKey/samples/:type',
        'org/:orgKey/samples/:type/:sampleKey',
        'org/:orgKey/eval-transfer/:sampleKey',
    ];

    private reportingPaths: string[] = [
        'org/:orgKey/advanced-reports',
        'org/:orgKey/advanced-reports/:reportKey',
    ];

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let pathType = this.getPathType(route.routeConfig.path);

        if (pathType === PathType.TASTINGS) return this.handleTastingsPath();
        if (pathType === PathType.EVALUATION) return this.handleEvaluationPath();
        if (pathType === PathType.REPORTING) return this.handleReportingModulePath();
        return false;
    }

    private handleTastingsPath(): boolean {
        return this._subscriptionHandler.checkSubscription(Subscriptions.TASTINGS);
    }

    private handleEvaluationPath(): boolean {
        return this._subscriptionHandler.checkSubscription(Subscriptions.EVALUATION);
    }

    private handleReportingModulePath(): boolean {
        return this._subscriptionHandler.checkSubscription(Subscriptions.REPORTING);
    }

    private getPathType(path: string): string {
        if (this.tastingsPaths.includes(path)) return PathType.TASTINGS;
        if (this.evaluationPaths.includes(path)) return PathType.EVALUATION;
        if (this.reportingPaths.includes(path)) return PathType.REPORTING;
    }
}